import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "./locales/en.json";
import translationCS from "./locales/cs.json";
import translationDE from "./locales/de.json";

const resources = {
  en: {
    translation: translationEN
  },
  cs: {
    translation: translationCS
  },
  de: {
    translation: translationDE
  }
};

i18n
  .use(LanguageDetector) 
  .use(initReactI18next) 
  .init({
    resources,
    fallbackLng: "cs", 
    interpolation: {
      escapeValue: false 
    }
  });

export default i18n;
